import React from 'react';
import './main.css'

function Main1() {
    return ( <>

     <ul>         
        <details>
            <summary>Market Insights 🎥 </summary>
            <p>Stay informed with our market updates:</p>
            <p>Market Watch: Trends, forecasts, and investment tips.</p>
            <p>Insider Tips: Navigating the real estate landscape.</p>
        </details>
        <details>
            <summary>Client-Focused Approach:  🎯  </summary>
            <p>Your goals are our priority.</p>
        </details>
        <details>
            <summary>Unlock Your Financial Potential: </summary>
            <p>Explore our curated investment opportunities. </p>
            <p>From residential properties to commercial spaces,</p>
            <p>  we’ve got options that fit your goals. </p>
        </details>
        <details>
            <summary> Investment Opportunities Await 🌟</summary>
            <p>Explore our curated investment opportunities.<br />
              From residential properties to commercial spaces, <br />
              we’ve got options that fit your goals. 🏢</p>
        </details>
        <details>
            <summary>Transparency:</summary>
            <p>No hidden fees or surprises. </p>
        </details>  
       
        <details>
            <summary>Don't Wait, Invest in Your Future Today!</summary>
            <p>Ready to take control of your financial future <br />
            and build lasting wealth?  Altero Management is here <br />
            to guide you every step of the way. </p>
        </details>    
     </ul>
    </> );
}

export default Main1;